import './style/global.less';
import React, { useEffect } from 'react';
import '@arco-design/web-react/dist/css/arco.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PageLayout from './layout';
import { GlobalContext } from './context';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './mock';
import { profile } from './request/api';
import Oauth from './pages/oauth';
import { LoginProvider, useLogin } from './context/LoginContext';
import { store } from './store';
import OauthEvaluate from './pages/oauthEvaluate';

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  // const { showLogin } = useLogin();

  // useEffect(() => {
  //   // setLoginHandler(showLogin); // 将 showLogin 注入拦截器
  // }, [showLogin]);

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: { userLoading: true },
    });
    profile({}).then((res) => {
      store.dispatch({
        type: 'update-userInfo',
        payload: { userInfo: res.data.profile, userLoading: false },
      });
    });
  }

  useEffect(() => {
    // 白名单不检查
    if (
      ['login', 'oauth', 'oauthEvaluate'].includes(
        window.location.pathname.replace(/\//g, '')
      )
    ) {
      return;
    }

    if (checkLogin()) {
      fetchUserInfo();
    }
  }, []);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <LoginProvider>
              <Switch>
                <Route path="/oauth" component={Oauth} />
                <Route path="/oauthEvaluate" component={OauthEvaluate} />
                <Route path="/" component={PageLayout} />
              </Switch>
            </LoginProvider>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));
